import { render, staticRenderFns } from "./yc-sales.vue?vue&type=template&id=016f3ae8&scoped=true&"
import script from "./yc-sales.vue?vue&type=script&lang=js&"
export * from "./yc-sales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016f3ae8",
  null
  
)

export default component.exports